import React, { useEffect, useState } from 'react';
import { Paper, Typography, Box, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, CircularProgress, Button, Dialog, DialogTitle, DialogContent, DialogActions } from '@mui/material';
import axios from 'axios';

const LANDLORD_API_BASE_URL = 'https://bunnyrent-backend-917484933271.us-central1.run.app/api';
const landlordApi = axios.create({
  baseURL: LANDLORD_API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});
landlordApi.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('landlord_access_token') || localStorage.getItem('access_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

export default function LandlordProgress() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [confirmDialog, setConfirmDialog] = useState({ open: false, idx: null, progressId: null });
  const [adFeeDialog, setAdFeeDialog] = useState({ open: false, idx: null, progressId: null });


  useEffect(() => {
    setLoading(true);
    landlordApi.get('/properties/progress/landlord/')
      .then(res => {
        setRows(res.data);
        setLoading(false);
      })
      .catch(err => {
        setError('加载失败');
        setLoading(false);
      });
  }, []);

  const handleConfirm = async () => {
    const { idx, progressId } = confirmDialog;
    try {
      await landlordApi.patch(`/properties/progress/${progressId}/landlord-confirm/`);
      setRows(prev => prev.map((row, i) => i === idx ? { ...row, landlord_confirmed: true } : row));
      setConfirmDialog({ open: false, idx: null, progressId: null });
    } catch (e) {
      alert('Failed to confirm.');
    }
  };

  const handleAdFee = async () => {
    const { idx, progressId } = adFeeDialog;
    try {
      await landlordApi.patch(`/properties/progress/${progressId}/ad-fee-complete/`);
      setRows(prev => prev.filter((row, i) => i !== idx));
      setAdFeeDialog({ open: false, idx: null, progressId: null });
    } catch (e) {
      alert('Failed to complete Ad Fee.');
    }
  };

  return (
    <Paper elevation={3} sx={{ p: 4, borderRadius: 3, bgcolor: 'background.paper', mt: 4 }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
        <Typography variant="h4" sx={{ color: 'primary.main', fontWeight: 700 }}>
          Signed Students
        </Typography>
      </Box>
      <Box sx={{ mt: 3 }}>
        {loading ? (
          <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: 200 }}>
            <CircularProgress />
          </Box>
        ) : error ? (
          <Typography color="error">Failed to load data</Typography>
        ) : rows.length === 0 ? (
          <Typography color="text.secondary">No signed students</Typography>
        ) : (
          <TableContainer>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Student Email</TableCell>
                  <TableCell>Student Name</TableCell>
                  <TableCell>Move-in Date</TableCell>
                  <TableCell>Property Title</TableCell>
                  <TableCell>Property Address</TableCell>
                  <TableCell>Landlord Confirmed</TableCell>
                  <TableCell>Ad Fee</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {rows.map((row, idx) => (
                  <TableRow key={idx}>
                    <TableCell>
                      {row.user_email}
                    </TableCell>
                    <TableCell>
                      {row.user_full_name}
                    </TableCell>
                    <TableCell>{row.move_in_date || '-'}</TableCell>
                    <TableCell>{row.rental_title}</TableCell>
                    <TableCell>{row.rental_address}</TableCell>
                    <TableCell>
                      {row.landlord_confirmed ? (
                        <span style={{ color: '#388e3c', fontWeight: 600 }}>Confirmed</span>
                      ) : (
                        <Button variant="outlined" size="small" color="primary" onClick={() => setConfirmDialog({ open: true, idx, progressId: row.id })}>
                          Confirm
                        </Button>
                      )}
                    </TableCell>
                    <TableCell>
                      {row.ad_fee_given ? (
                        <span style={{ color: '#388e3c', fontWeight: 600 }}>Completed</span>
                      ) : (
                        <Button variant="outlined" size="small" color="secondary" onClick={() => setAdFeeDialog({ open: true, idx, progressId: row.id })}>
                          Complete Ad Fee
                        </Button>
                      )}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </Box>
      
      {/* 确认弹窗 */}
      <Dialog open={confirmDialog.open} onClose={() => setConfirmDialog({ open: false, idx: null, progressId: null })}>
        <DialogTitle>Confirm Action</DialogTitle>
        <DialogContent>Are you sure you want to confirm this progress? This action cannot be undone.</DialogContent>
        <DialogActions>
          <Button onClick={() => setConfirmDialog({ open: false, idx: null, progressId: null })}>Cancel</Button>
          <Button variant="contained" color="primary" onClick={handleConfirm}>Confirm</Button>
        </DialogActions>
      </Dialog>
      
      {/* 广告费弹窗 */}
      <Dialog open={adFeeDialog.open} onClose={() => setAdFeeDialog({ open: false, idx: null, progressId: null })}>
        <DialogTitle>Complete Ad Fee</DialogTitle>
        <DialogContent>Are you sure you want to complete Ad Fee? This action cannot be undone.</DialogContent>
        <DialogActions>
          <Button onClick={() => setAdFeeDialog({ open: false, idx: null, progressId: null })}>Cancel</Button>
          <Button variant="contained" color="secondary" onClick={handleAdFee}>Complete</Button>
        </DialogActions>
      </Dialog>
    </Paper>
  );
} 